import { HttpClient, HttpContext } from "@angular/common/http";
import { InjectionToken, inject } from "@angular/core";

import { Observable, takeWhile } from "rxjs";

import { CAE } from "@models";

import { ClientService } from "./client.service";

interface AppConfig {
  publicUrl: string;
  engineUrl: string;
  wsUrl: string;
}

export const APP_CONFIG = new InjectionToken<AppConfig>("APP_CONFIG");

export abstract class HttpService {
  private readonly hC = inject(HttpClient);
  private readonly clS = inject(ClientService);

  protected abstract apiUrl: string;
  protected abstract domain: string;

  protected post<T>(path: string, body: object): Observable<T> {
    return this.process<T>(this.hC.post<T>(this.getPath(path), body, { context: this.context }));
  }

  protected get<T>(path: string): Observable<T> {
    return this.process<T>(this.hC.get<T>(this.getPath(path), { context: this.context }));
  }

  private process<T>(req: Observable<T>): Observable<T> {
    if (this.clS.stop$()) {
      throw new Error("The client ends the interaction.");
    }

    return req.pipe(takeWhile(() => !this.clS.stop$()));
  }

  private getPath(path: string): string {
    return `${this.apiUrl}/${this.domain}${path}`;
  }

  private get context(): HttpContext {
    return new HttpContext().set(CAE, true);
  }
}
